import { NumberCell } from '@ayocore/platform/client/components/EditableGrid';
import type { SupplierQuoteColumnKey, SupplierQuoteLike, SupplierQuotePatch } from './types';

export const quoteQtyAvailableColumn = NumberCell<
  SupplierQuoteLike,
  SupplierQuotePatch,
  SupplierQuoteColumnKey
>({
  key: 'qty_available',
  title: 'Доступно',
  width: 100,
  nullable: true,
  precision: 0,
  minValue: 0,
});
